import { useInView } from "@/hooks/useInView";

interface RevealWordsProps {
  text: string;
  className?: string;
  wordClassName?: string;
  baseDelay?: number; // ms
  step?: number; // ms
  threshold?: number;
}

/**
 * Splits the given text on whitespace, wraps each word in an
 * overflow-clipped span, and slides each word up from below
 * when the component enters the viewport — staggered.
 */
export default function RevealWords({
  text,
  className = "",
  wordClassName = "",
  baseDelay = 80,
  step = 110,
  threshold = 0.25,
}: RevealWordsProps) {
  const { ref, inView } = useInView<HTMLSpanElement>({ threshold });
  const words = text.split(/\s+/);
  return (
    <span ref={ref} className={`inline ${className}`}>
      {words.map((w, i) => (
        <span
          key={`${w}-${i}`}
          className={`lum-word-reveal ${inView ? "is-visible" : ""} ${wordClassName}`}
          style={{ marginRight: "0.28em" }}
        >
          <span
            style={{ transitionDelay: `${baseDelay + i * step}ms` }}
          >
            {w}
          </span>
        </span>
      ))}
    </span>
  );
}